import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Campfire Orange es el color de acción de la página (texto Pine Ink encima,
 * contraste ~6.5:1). Signal Red queda reservado para tensión y seguridad.
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-[17px] sm:text-xl rounded-2xl min-h-[60px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 text-center bg-ember hover:bg-ember-hover text-pine font-bold tracking-wide shadow-card hover:shadow-lift transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-paper/70 ${sizing} ${className}`} data-id="element-76" data-mp="ll7axj7l6tkv">
      {children}
    </a>;
}